import { render } from "./TicketView.vue?vue&type=template&id=65c9fc06"
import script from "./TicketView.vue?vue&type=script&lang=js"
export * from "./TicketView.vue?vue&type=script&lang=js"

import "./TicketView.vue?vue&type=style&index=0&id=65c9fc06&lang=css"

import exportComponent from "/Users/daniel/Documents/CETECREA/cetecrea/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__